export const getAddAdminPurchaseReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_ADMIN_PURCHASE_REQUEST":
      return {
        loading: true,
        ...state,
      };
    case "ADD_ADMIN_PURCHASE_SUCCESS":
      return {
        loading: false,
        success: true,
      };
    case "ADD_ADMIN_PURCHASE_FAILED":
      return {
        loading: false,
        error: action.payload,
      };

    case "ALL_ADMIN_PURCHASE_CLEAR":
      return {
        loading: false,
        success: false,
      };

    default:
      return state;
  }
};

export const getAllAdminPurchaseReducer = (
  state = { admin_purchase: [] },
  action
) => {
  switch (action.type) {
    case "GET_ADMIN_PURCHASE_REQUEST":
      return {
        loading: true,
        ...state,
      };
    case "GET_ADMIN_PURCHASE_SUCCESS":
      return {
        loading: false,
        admin_purchase: action.payload,
      };
    case "GET_ADMIN_PURCHASE_FAILED":
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
